import React, { useEffect } from 'react'
import styled from 'styled-components'
import useFetch from '../../../../hook/useFetch'

import { Link } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'

import { getLandingPage } from '../../../../pages/features/landingpage/landingpageSlice'

import { PopularNigerianaData } from '../../../../popularnigerianadata'

import { 
    BoxContainer,
    ImageContainer,
    PostCard,
    TextContainer,
 } from '../../../../components/postCard'

import{
    Container,
    HeaderContainer,
    NavLink
} from '../popularcategories'




const PopularNigeriana = () => {

    const dispatch = useDispatch

    const { landingPage, landingStatus} = useSelector(state => state?.landingPage)


    useFetch(getLandingPage);


  return (
    <Container>
        <HeaderContainer>
            <h2>Popular Nigeriana</h2>
            <h5> <NavLink to='/nigeriana' >View all</NavLink> </h5>
        </HeaderContainer>

        <CardsContainer>

            {
                landingPage?.recentlyModifiedInternalResources?.slice(0, 20)?.map((popular) => {
                    return(
                        <PostCard popular={popular} key={popular?.resourceId} />
                    )
                })
            }
            

        </CardsContainer>
    </Container>
  )
}

export const CardsContainer = styled.div`
    width: 100%;
    max-width: 1250px;
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    flex-direction: row;
    justify-content: space-between;
    /* flex-wrap: wrap; */
    margin-top: 20px;

    @media screen and (max-width: 600px){
            justify-content: center;
            display: flex;
            flex-wrap: wrap;
        }
    
    
`



export {PopularNigeriana}